<div class="nav-item d-flex flex-column align-items-start"
    [tooltip]="isExpanded() ? '' : name()"
    [tooltip-error]="licensed() == false ? 'License Insufficient' : undefined"
    [tooltip-placement]="uiService.isMobile() ? 'auto' : 'right'"
    [class]="{
        'active': active(),
        'disabled': licensed() == false,
        'no-license': licensed() == false,
        'expanded': isExpanded()
    }"
>
    @if(licensed() == false){
        <fa-icon class="no-license-icon color--red-500 font-size-09rm" [icon]="['fad', 'circle-exclamation']"/>
    }
    <div class="nav-item-content d-flex gap-1 flex-row align-items-center justify-content-center">
        <div class="nav-item-icon-container d-flex flex-column align-items-center justify-content-center">
            <ng-content/>
        </div>
        @if(isExpanded()){
            <span class="font-size-08rm font-secondary text-single-line pe-2" [class]="{
                'color--white-100-70': !isCurrent(),
                'color--accent-primary': isCurrent()
            }">{{name()}}</span>
        }
    </div>
</div>